import { hu } from "../../../../date-fns/locale/hu.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    hu
  }
};